export default "__VITE_PUBLIC_ASSET__99168af4__"